<template>
  <div
    class="ticon-component"
    :style="`
      fill: ${icon_color};
      width: ${icon_size}px;
      height: ${icon_size}px;
      ${ dropshadow ? 'filter: drop-shadow(1px 2px #0007);' : ''}
      ${ shadow ? `filter: drop-shadow(3px 3px 2px ${shadow_color});` : ''}
    `"
    v-html="getSVGIcon(name)"
  />
  <!-- @click.prevent.stop="$emit('clickIcon')" -->
</template>

<script>
import { mapGetters } from 'vuex';
import { TColor } from '@/mixins/TColor.mixin.js';
// import colors from 'vuetify/lib/util/colors';

  export default {
    props: [
      'name', // id of icon
      'color', // color of icon, either hex-color or vuetify
      'size', // size in px
      'is_disabled'

      // legacy props, these are passed differently
      // 'small', // defaults to smallest scale
      // 'medium', // defaults to second to smallest scale
      // 'large', // defaults to second to largest scale
      // 'giant', // defaults to largest scale
      // 'shadow', // toggles shadow on

    ],

    mixins: [
      TColor
    ],

    data: () => ({
      basePath: '/static',
      default_size: 24,
      size_scale: [16, 24, 36, 48],
    }),

    computed: {
      ...mapGetters('Icon', [
        'getSVGIcon',
      ]),

      icon_size() {
        // if a size is specified ignore booleans
        if(this.size) {
          return this.size;
        }

        let size_index;
        // larger sizes are preferred when multiple booleans are toggled
        let a = this.$attrs;
        if(a.small !== undefined) {
          if(a.small || a.small === '')
            { size_index = 0; } }
        if(a.medium !== undefined) {
          if(a.medium || a.medium === '')
            { size_index = 1; } }
        if(a.large !== undefined) {
          if(a.large || a.large === '')
            { size_index = 2; } }
        if(a.giant !== undefined) {
          if(a.giant || a.giant === '')
            { size_index = 3; } }

        return this.size_scale[size_index] || this.default_size;
      },

      icon_color() {
        if(this.color) {
          let c =  this.getColor(this.color);
          if(this.is_disabled){
            return this.getTranspHexColor(c, 0.5);
          }
          return c;
        }
        else if(this.rainbow) {
          return 'url(#rainbow-gradient) #fff';
        }
        else {
          return 'inherit';
        }
      },

      shadow() {
        let a = this.$attrs;
        if (a.shadow !== undefined) {
          if (a.shadow || a.shadow === '') { return true; }
        }
        return false;
      },

      dropshadow() {
        let a = this.$attrs;
        if (a.dropshadow !== undefined) {
          if (a.dropshadow || a.dropshadow === '') { return true; }
        }
        return false;
      },

      shadow_color() {
        let a = this.$attrs;
        if(a.shadow !== undefined) {
          if(a.shadow === '' || a.shadow.length === undefined) {
            return this.getTranspHexColor('#000', 0.3);
          }
          else {
            return this.getColor(a.shadow);
          }
        }
        return '#0000';
      },

      // svg() {
      //   return `
      //     <svg
      //       width="${ this.icon_size }px"
      //       height="${ this.icon_size }px"
      //     >
      //       <use xlink:href="${ this.basePath }/iconsWIP.svg#${ this.name || 'error' /* default icon here */ }"></use>
      //     </svg>
      //   `;
      // }
    },
  }
</script>

<style>
.ticon-component {
  display: flex;
  transition: transform 0.2s ease-in-out,
              opacity 0.2s ease-in-out,
              fill 0.1s ease-in-out;
  flex-shrink: 0;
  /* TODO: Discuss if this is needed */
  /* pointer-events: none; /*NOTE: icons themselves are not clickable, if needed place them in button element*/
}
</style>
